<template>
  <div
    v-if="totalPages > 0"
    class="pagination-container"
    :style="paginationContainerStyle"
  >
    <div
      class="pagination__body"
      :class="{ showPerPageDropdown: showPerPageDropdown }"
    >
      <div
        class="pagination__main"
        :class="{ showPerPageDropdown: showPerPageDropdown }"
        :style="paginationMainStyle"
      >
        <div>
          <div class="pagination-pages" v-if="totalPages > 1">
            <button
              :class="{ 'active-class': button.active }"
              class="button-style"
              :disabled="button.disabled"
              :title="button.title"
              v-for="(button, key) in buttons"
              :key="key"
              @click="
                handlepageChange(button.page, button.disabled, button.active)
              "
            >
              <i v-if="loading" class="fa fa-spinner fa-spin" />
              <span v-else v-html="button.html" />
            </button>
          </div>

          <p class="pagination__total" v-if="showResultsCount">
            {{ totalItems }} Result(s)
          </p>
        </div>
      </div>
      <div class="per-page" v-if="showPerPageDropdown">
        <div>
          <p>Results Per Page</p>
          <!-- <select v-model="perPage" @change="$emit('perPageChange', perPage)">
            <option v-for="i in perPageOptions" :key="i" :value="i">{{
              i
            }}</option>
          </select> -->
          <v-select
            class="glass pagination"
            :options="perPageOptions"
            :clearable="false"
            :searchable="false"
            :appendToBody="isManageInventory ? true : false"
            v-model="perPage"
            @input="$emit('perPageChange', perPage)"
          >
            <!-- Option Slot -->
            <template #option="{ perPageOptions }">
              <h3 v-for="page in perPageOptions" :key="page" style="margin: 0;">
                {{ page }}
              </h3>
            </template>

            <!-- Toggle Icon Slot -->
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <svg
                  class="drop-icon"
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.5 5C4.38766 5 4.27531 4.95646 4.18974 4.86983L0.128691 0.758491C-0.0428968 0.584779 -0.0428968 0.303996 0.128691 0.130284C0.300278 -0.043428 0.577626 -0.043428 0.749214 0.130284L4.5 3.92752L8.25079 0.130284C8.42237 -0.043428 8.69972 -0.043428 8.87131 0.130284C9.0429 0.303996 9.0429 0.584779 8.87131 0.758491L4.81026 4.86983C4.72469 4.95646 4.61234 5 4.5 5Z"
                    fill="#25282A"
                  />
                </svg>
              </span>
            </template>
          </v-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueAdsPageButton from './PageButton'

export default {
  name: 'VueAdsPagination',

  data: () => ({
    perPage: ''
  }),
  props: {
    page: {
      type: Number,
      default: 0,
      validator: page => {
        return page >= 0
      }
    },

    itemsPerPage: {
      type: Number,
      default: 10,
      validator: itemsPerPage => {
        return itemsPerPage > 0
      }
    },

    maxVisiblePages: {
      type: Number,
      default: 5,
      validator: maxVisiblePages => {
        return maxVisiblePages > 0
      }
    },

    totalItems: {
      type: Number,
      required: true,
      validator: totalItems => {
        return totalItems >= 0
      }
    },

    showResultsCount: {
      type: Boolean,
      default: true
    },
    showPerPageDropdown: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    perPageOptions: {
      type: Array,
      default: () => [10, 30, 50],
      requied: false
    },
    paginationContainerStyle: {
      type: String,
      default: ''
    },
    paginationMainStyle: {
      type: String,
      default: ''
    }
  },

  computed: {
    isManageInventory() {
      return this.$route.path.includes('manage-inventory')
    },

    start() {
      return this.page * this.itemsPerPage
    },

    end() {
      let end = this.start + this.itemsPerPage

      return this.totalItems < end ? this.totalItems : end
    },

    totalPages() {
      if (this.itemsPerPage === 0) {
        return 0
      }

      return Math.ceil(this.totalItems / this.itemsPerPage)
    },

    pages() {
      let filteredPages = this.filteredPages
      let pages = filteredPages
        ? [
            filteredPages[0] - 1 === 1 ? 1 : '...',
            ...filteredPages,
            filteredPages[filteredPages.length - 1] + 1 === this.totalPages - 2
              ? this.totalPages - 2
              : '...'
          ]
        : [...Array(this.totalPages - 2).keys()].map(page => page + 1)

      return [this.page - 1, 0, ...pages, this.totalPages - 1, this.page + 1]
    },

    filteredPages() {
      let diff = this.maxVisiblePages / 2
      let toFilterPages = [...Array(this.totalPages).keys()].slice(2, -2)

      if (toFilterPages.length > this.maxVisiblePages) {
        let diffFirst = this.page - toFilterPages[0]
        let diffLast = this.page - toFilterPages[toFilterPages.length - 1]

        if (diffFirst < diff) {
          return toFilterPages.slice(0, this.maxVisiblePages)
        } else if (diffLast >= -diff) {
          return toFilterPages.slice(-this.maxVisiblePages)
        } else {
          return toFilterPages.filter(page => {
            let diffPage = this.page - page

            return diffPage < 0 ? Math.abs(diffPage) <= diff : diffPage < diff
          })
        }
      }

      return null
    },

    buttons() {
      return this.pages.map((page, key) => {
        return {
          page,
          active: page === this.page,
          disabled: this.disabled(page, key),
          html: this.html(page, key),
          title: this.title(key),
          loading: this.loading && page === this.page
        }
      })
    }
  },
  mounted() {
    this.perPage = this.itemsPerPage
  },
  watch: {
    itemsPerPage: {
      handler: 'rangeChange'
    },

    totalItems: {
      handler: 'rangeChange'
    }
  },

  methods: {
    handlepageChange(page, disabled, active) {
      if (page === '...' || disabled || active) {
        return
      }
      this.$emit('page-change', page)
    },
    pageChange(page) {
      if (page >= this.totalPages && page !== 0 && this.totalPages !== 0) {
        throw new Error(
          'page may be maximum the total number of pages minus one'
        )
      }

      this.rangeChange()
    },

    rangeChange() {
      if (this.page >= this.totalPages && this.totalPages !== 0) {
        this.$emit('page-change', this.totalPages - 1)
      } else {
        this.$emit('range-change', this.start, this.end)
      }
    },

    html(page, key) {
      if (key === 0) {
        return '<svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.5c0-.11234.04354-.22469.13017-.31026L4.24151.12869c.17371-.17159.45449-.17159.62821 0a.43458.43458 0 0 1 0 .62052L1.07248 4.5l3.79724 3.75079a.43457.43457 0 0 1 0 .62052c-.17372.17159-.4545.17159-.62821 0L.13017 4.81026C.04354 4.72469 0 4.61234 0 4.5Z" fill="#25282A"/></svg>'
      }

      if (key === this.pages.length - 1) {
        return '<svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4.5c0 .11234-.04354.22469-.13017.31026L.75849 8.87131c-.17371.17159-.4545.17159-.6282 0a.43457.43457 0 0 1 0-.62052L3.92751 4.5.13028.74921a.43457.43457 0 0 1 0-.62052C.304-.0429.58478-.0429.7585.1287l4.11134 4.06105C4.95646 4.27531 5 4.38766 5 4.5Z" fill="#25282A"/></svg>'
      }

      if (page === '...') {
        return page
      }

      return page + 1 + ''
    },

    disabled(page, key) {
      return (
        (key === 0 && this.page === 0) ||
        (key === this.pages.length - 1 && this.page === this.totalPages - 1) ||
        page === '...'
      )
    },

    title(key) {
      if (key === 0) {
        return 'previous'
      }

      if (key === this.pages.length - 1) {
        return 'next'
      }

      return ''
    }
  }
}
</script>
<style scoped lang="scss">
select {
  border: none;
  padding-top: 0;
  padding-bottom: 0;
  /* padding: 0; */
}
.pagination-container {
  margin-top: 2rem;
  position: relative;
  z-index: 4;
}

.pagination__body {
  display: block;

  &.showPerPageDropdown {
    display: flex;
  }
}
.pagination__main {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  /* align-items: center; */

  &.showPerPageDropdown {
    width: 55%;
  }
}
.pagination-pages {
  margin-bottom: 1rem;

  .button-style:last-child {
    margin-right: 0px;
  }
}
.pagination__total {
  padding-top: 0.5rem;
  font-size: 0.813rem;
}
.button-style {
  outline: none;
  color: #24292c;
  font-size: 0.875rem;
  padding: 0.25rem;
  border: none;
  background: none;
  cursor: pointer;
  margin: 0.5rem 0.75rem;
}
.active-class {
  border-bottom: 1px solid black !important;
  font-weight: bold;
}
span svg {
  padding: 0.5rem;

  &.drop-icon {
    padding: 0;
    margin-top: 9px;
  }
}
.per-page {
  display: flex;
  justify-content: flex-end;
  width: calc(100% - 55%);

  .glass {
    width: 5rem;
    border-bottom: 1px solid;
    height: 35px;
  }
}

.per-page div {
  display: flex;
  /* align-items: center; */
}
.per-page div p {
  width: 100%;
  margin-right: 1rem;
  white-space: nowrap;
  padding-top: 0.75rem;
  font-size: 0.813rem;
}

@media screen and (max-width: 630px) and (min-width: 350px) {
  .pagination__main {
    justify-content: flex-start;
  }
}
</style>
